var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ring-loader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ]
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading"
            }
          ],
          staticClass: "row"
        },
        [
          _c("div", { staticClass: "row margin-bottom-20" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "form-group col-md-3" },
                [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("trans")("fiscalization_report.date_from")
                        ) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("date-picker", {
                    attrs: { time: false, "is-nullable": false },
                    model: {
                      value: _vm.dateFrom,
                      callback: function($$v) {
                        _vm.dateFrom = $$v
                      },
                      expression: "dateFrom"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group col-md-3" },
                [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("trans")("fiscalization_report.date_to")
                        ) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("date-picker", {
                    attrs: { time: false, "is-nullable": false },
                    model: {
                      value: _vm.dateTo,
                      callback: function($$v) {
                        _vm.dateTo = $$v
                      },
                      expression: "dateTo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group col-md-3" },
                [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("trans")("fiscalization_report.brand")) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("single-select", {
                    staticClass: "brand-multiselect",
                    attrs: {
                      checked: _vm.brand,
                      options: _vm.brands,
                      "allow-empty": false
                    },
                    model: {
                      value: _vm.brand,
                      callback: function($$v) {
                        _vm.brand = $$v
                      },
                      expression: "brand"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-md-3" }, [
                _c("label", { staticClass: "control-label col-md-12" }, [
                  _vm._v(" ")
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    on: { click: _vm.getReport }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("trans")("fiscalization_report.download")
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.length,
                  expression: "errors.length"
                }
              ],
              staticClass: "row"
            },
            [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "alert alert-danger",
                      attrs: { role: "alert" }
                    },
                    [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")("fiscalization_report.error")
                          ) + ":"
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.errors, function(error, index) {
                        return _c("p", { key: index }, [_vm._v(_vm._s(error))])
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-232808e6", { render: render, staticRenderFns: staticRenderFns })
  }
}